import PropTypes from "prop-types";
import { useEffect } from "react";
import { Controller, useFormContext } from "react-hook-form";

import { Paper } from "@mui/material";
import Grid from "@mui/material/Grid";

import {
  AllOutletsSelect,
  OutletRoleEnum,
  UserOutletsSelect,
} from "@/features/outlets";
import { SupplierSelect } from "@/features/suppliers";
import { CustomDatePicker } from "@/features/ui";

export const GeneralInformationSection = ({ editMode = false }) => {
  const { watch, control, setValue } = useFormContext();

  const buyer = watch("buyer");
  const sellerableType = watch("sellerableType");
  const purchaseOrder = watch("purchaseOrder");

  const disableBuyerSeller = Boolean(purchaseOrder);

  useEffect(() => {
    if (buyer) {
      const nextSellerableType =
        buyer.role === OutletRoleEnum.HUB ? "SUPPLIER" : "OUTLET";
      setValue("sellerableType", nextSellerableType);
    }
  }, [buyer, setValue]);

  useEffect(() => {
    if (editMode) return;

    if (sellerableType) {
      setValue("seller", null);
    }
  }, [sellerableType, editMode, setValue]);

  return (
    <Paper sx={{ p: 2.5, borderRadius: 2 }}>
      <Grid container spacing={3}>
        <Grid size={{ xs: 12, sm: 6, lg: 4 }}>
          <Controller
            control={control}
            name="buyer"
            render={({ field, fieldState }) => (
              <UserOutletsSelect
                value={field.value}
                onChange={field.onChange}
                disabled={editMode || disableBuyerSeller}
                TextFieldProps={{
                  label: "Pembeli",
                  required: true,
                  error: fieldState.invalid,
                  helperText: fieldState.error?.message,
                }}
              />
            )}
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 6, lg: 4 }}>
          <Controller
            control={control}
            name="seller"
            render={({ field, fieldState }) =>
              sellerableType === "OUTLET" ? (
                <AllOutletsSelect
                  value={field.value}
                  onChange={field.onChange}
                  disabled={editMode || disableBuyerSeller}
                  allowedRoles={[OutletRoleEnum.HUB]}
                  TextFieldProps={{
                    label: "Pemasok (Hub)",
                    required: true,
                    error: fieldState.invalid,
                    helperText: fieldState.error?.message,
                  }}
                />
              ) : (
                <SupplierSelect
                  withPaymentTerm={true}
                  value={field.value}
                  onChange={field.onChange}
                  disabled={editMode || disableBuyerSeller}
                  TextFieldProps={{
                    label: "Pemasok (Eksternal)",
                    required: true,
                    error: fieldState.invalid,
                    helperText: fieldState.error?.message,
                  }}
                />
              )
            }
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 6, lg: 4 }}>
          <Controller
            name="transactionDate"
            control={control}
            render={({ field, fieldState }) => (
              <CustomDatePicker
                value={field.value}
                onChange={field.onChange}
                required
                label="Tanggal Transaksi"
                error={!!fieldState.error}
                helperText={fieldState.error?.message}
                InputProps={{
                  disableFuture: true,
                }}
              />
            )}
          />
        </Grid>
      </Grid>
    </Paper>
  );
};

GeneralInformationSection.propTypes = {
  editMode: PropTypes.bool,
};
